import React from 'react';

const WizardContext = React.createContext({
    currentStep: 'intro',
    setCurrentStep: (stepName) => {}
})

export default WizardContext;

